import { useAuth0 } from "@auth0/auth0-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/verify")({
  component: Verify
});

function Verify() {
  const { loginWithRedirect } = useAuth0();
  loginWithRedirect({
    authorizationParams: {
      redirect_uri: `${window.location.origin}`
    }
  });
}
